import script from "./HeroBackgroundGradientGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroBackgroundGradientGroup.vue?vue&type=script&setup=true&lang=ts"

import "./HeroBackgroundGradientGroup.vue?vue&type=style&index=0&id=ab8577d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab8577d6"]])

export default __exports__